module.exports = __webpack_public_path__ + "assets/b0bf014a9a96390b16e02e01a71750de.mp3";